import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { NgForm } from '@angular/forms';
import { AdditionalIncomeSource, AdditionalIncomeSourceType } from 'src/app/models/Argyle';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { Screening } from 'src/app/models/screeningInvite';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';


@Component({
  selector: 'app-income-source-modal',
  templateUrl: './income-source-modal.component.html',
  styleUrls: ['./income-source-modal.component.less']
})
export class IncomeSourceModalComponent implements OnInit, OnDestroy {
  @ViewChild('incomeSrc', {}) ngForm: NgForm;
  @Input() screeningId : number;
  @Input() applicantName : string;
  @Input() sourceTypes : any[];
  @Input() showSnapptToggle : boolean = false;
  @Input() addingFromVerified : boolean = false;
  snapptDocsVerified : boolean =false;
  saving : boolean = false;
  @Input() newSource: AdditionalIncomeSource;
  // @Input() groupscrns : Screening[];
  @Output() public hasUnverifiedIncome: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public saved : EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public closed : EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public modalService: NgbModal, private toast: ToastrService, private auth: AuthService, public appData: ApplicantDataService,public groups: GroupApplicantsService) { }
  ngOnDestroy(): void {
    // throw new Error("Method not implemented.");
  }
  ngOnInit(): void {
    // throw new Error("Method not implemented.");
    if(!this.newSource)
      this.newSource = new AdditionalIncomeSource();
    // else console.log('got a edit source', this.newSource);
  }

  public get groupscrns() : Screening[] {
    if(!this.groups.groupScreenings) return [];
    else return this.groups.groupScreenings;
  }

  cancel(){
    this.closed.emit(true);
  }

  toggleVerified(){
    // console.log('bout to toggle',this.newSource);
    this.newSource.incomeVerified = !this.newSource.incomeVerified;
    // console.log('toggled',this.newSource);
  }

  saveRule(){
    // console.log(this.newSource);
    this.newSource.screeningId = this.screeningId;
    this.saving = true;
    if(this.ngForm.status == 'VALID')
    {
      if(!this.newSource.maappedFromIncomeVer) this.newSource.maappedFromIncomeVer = this.addingFromVerified;
      this.appData.SaveAdditionalIncomeSource(this.newSource).subscribe((scc: AdditionalIncomeSource)=>{
        this.newSource.id = scc.id;
        this.saved.emit(true);
        this.cancel()
      },(err: any)=>{
        this.toast.error('Error Saving Income Source');
      },()=> {
        this.saving = false;
      });
    }
  }
}
